document.addEventListener('DOMContentLoaded', function () {
    var formGroups = document.querySelectorAll('.form__group input, .form__group textarea');

    formGroups.forEach(function (input) {
        input.addEventListener('focus', function () {
            input.parentNode.classList.add('active');
        });

        input.addEventListener('blur', function () {
            if (input.value.trim() === '') {
                input.parentNode.classList.remove('active');
            }
        });

        input.addEventListener('input', function () {
            var formGroup = input.parentNode;

            if (input.value.trim() !== '') {
                formGroup.classList.add('active');
            } else {
                formGroup.classList.remove('active');
            }
        });
    });
});

// Map

mapboxgl.accessToken =
    "pk.eyJ1Ijoic3Vvd2VpLWh1IiwiYSI6ImNsa2piOXIzNDBxMGozZXBpMTdtNjR1cWMifQ.rlNVGKY8-vvA8cA7chyN3g";
const map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/light-v11", // style URL
    interactive: true,
    animate: true,
    center: [20.0369122001694, 51.62012410893681], // starting position [lng, lat]
    zoom: 4 // starting zoom
});

// Add geolocate control to the map.
map.addControl(
  position=new mapboxgl.GeolocateControl({
    positionOptions: {enableHighAccuracy: true},
    // When active the map will receive updates to the device's location as it changes.
    trackUserLocation: true,
    // Draw an arrow next to the location dot to indicate which direction the device is heading.
    showUserHeading: true
  }),
  position="bottom-left"
);

// // Add zoom and rotation controls to the map.
map.addControl(
    control = new mapboxgl.NavigationControl(),
    position = "bottom-right"
);

// Create a popup window indicating the location detail / address
const popupCzestochowa = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    closeOnMove: false,
    anchor: "left",
    className: "mapbox-popup-box",
    offset: [45, 45]
})
    .setHTML(
        `
  <h4>Kancelaria Dawid & Partnerzy</h4>
  Adwokaci i Radcowie Prawni sp.k.<br>
  Jana Kilińskiego 30<br>
  42-200 Częstochowa<br>
  <a href="tel:343651864">34 365 18 64</a>
  <br><br>
  Godziny otwarcia:<br>
  8:00 - 19:00<br>
`
    )
    .setLngLat([19.114301674755264, 50.81513493113903])
    .setMaxWidth("5200px");

// Create a default Marker, colored black, rotated 45 degrees.
const marker1 = new mapboxgl.Marker({color: "#0E2F1A", rotation: 0})
    .setLngLat([19.114301674755264, 50.81513493113903])
    .setPopup(popupCzestochowa)
    .addTo(map);

// popupCzestochowa.addTo(map);

// Create a popup window indicating the location detail / address
const popupWarsaw = new mapboxgl.Popup({
    closeOnClick: false,
    closeButton: false,
    closeOnMove: false,
    anchor: "left",
    className: "mapbox-popup-box",
    offset: [45, 45]
})
    .setHTML(
        `
  <h4>Kancelaria Dawid & Partnerzy</h4>
  Adwokaci i Radcowie Prawni sp.k.<br>
  Mokotowska 57<br>
  00-542 Warszawa<br>
  <a href="tel:223759030">22 375 90 30</a><br><br>
  Godziny otwarcia:<br>
  8:30 - 19:00<br>
`
    )
    .setLngLat([21.02145248046587, 52.2254548243344])
    .setMaxWidth("5200px");

// Create a default Marker, colored black, rotated 45 degrees.
const marker2 = new mapboxgl.Marker({color: "#182B42", rotation: 0})
    .setLngLat([21.02145248046587, 52.2254548243344])
    .setPopup(popupWarsaw)
    .addTo(map);

// popupWarsaw.addTo(map);

// mapLock
document.addEventListener('DOMContentLoaded', function() {
    var disableMap = document.querySelector('.disableMap');
    var map = document.getElementById('map');

    disableMap.addEventListener('click', function() {
        // Sprawdź, czy '.disableMap' ma klasę '.unlocked'
        var isUnlocked = disableMap.classList.contains('unlocked');

        // Toggle klasę '.unlocked' na '.disableMap'
        if (isUnlocked) {
            disableMap.classList.remove('unlocked');
        } else {
            disableMap.classList.add('unlocked');
        }

        // Toggle klasę '.interactive' na '#map'
        if (isUnlocked) {
            map.classList.remove('interactive');
        } else {
            map.classList.add('interactive');
        }
    });
});